/**************************************************************************************************/
/*   File: /src/app/shared/models/report.status.ts                                                */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday March 29th 2019                                                         */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Mar 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { ReportStatusEnum } from '../enums';

/**
 * The report status
 */
export class ReportStatus {
    /**
     * The description
     */
    description: string;
    /**
     * The status
     */
    status: ReportStatusEnum;
}